import { useIntl } from "react-intl";
import { InputActionMeta } from "react-select";

import Input from "components/v2/Input/Input";
import Select from "components/v2/Select/Select";
import { useEmailPasteCleanup } from "@RequestFormV2/sections/Schedule/hooks/useEmailPasteCleanup";
import { useSharedContact } from "@RequestFormV2/sections/Schedule/hooks/useSharedContact";
import { formatContactOptionLabel } from "@RequestFormV2/sections/Schedule/utils/selectOptionLabel";
import type { SharedContactFieldPaths } from "@RequestFormV2/sections/Schedule/utils/sharedAddressFieldPaths";

interface SharedContactSectionProps {
  fieldPaths: SharedContactFieldPaths;
  fieldsDisabled: boolean;
  isRequired: boolean;
  contactNameTestId?: string;
  contactPhoneTestId?: string;
  contactEmailTestId?: string;
}

export default function SharedContactSection({
  fieldPaths,
  fieldsDisabled,
  isRequired,
  contactNameTestId,
  contactPhoneTestId,
  contactEmailTestId,
}: SharedContactSectionProps) {
  const intl = useIntl();
  const contact = useSharedContact(fieldPaths, fieldsDisabled);
  const handleEmailPaste = useEmailPasteCleanup(fieldPaths.contact_email);

  const contactRequired = isRequired && !fieldsDisabled;

  return (
    <div className="rfv2-contact-grid">
      <Select
        name={fieldPaths.contact_name}
        label={intl.formatMessage({ id: "general.name", defaultMessage: "Name" })}
        required={contactRequired}
        options={contact.contactSearchResults}
        onChange={contact.handleContactSelect}
        onInputChange={(val: string, meta: InputActionMeta) => contact.handleContactNameInputChange(val, meta)}
        filterOption={() => true}
        isLoading={contact.isLoadingContacts}
        formatOptionLabel={formatContactOptionLabel}
        isClearable
        tabSelectsValue={false}
        isDisabled={fieldsDisabled}
        testId={contactNameTestId}
      />
      <Input
        name={fieldPaths.contact_phone}
        label={intl.formatMessage({ id: "general.phone", defaultMessage: "Phone" })}
        testId={contactPhoneTestId}
        disabled={fieldsDisabled}
        required={contactRequired}
      />
      <Input
        name={fieldPaths.contact_email}
        label={intl.formatMessage({ id: "general.email", defaultMessage: "Email" })}
        onPaste={handleEmailPaste}
        testId={contactEmailTestId}
        disabled={fieldsDisabled}
        required={contactRequired}
      />
    </div>
  );
}
